export default __webpack_public_path__ + "static/media/gallery-2.146bc376.jpg";